class CustomTabs extends HTMLElement {
    constructor() {
        super();
        this.tabHeaders = Array.from(this.querySelectorAll('tab-header'));
        this.tabContents = Array.from(this.querySelectorAll('tab-content'));
        this.tabLinks = Array.from(this.querySelectorAll('tab-link'));
        this.tabLinksMobile = Array.from(this.querySelectorAll('tab-link-mobile'));
        this.enableDot = false;
        this.animationType = this.dataset.animationType || 'slide';

        if(!this.tabHeaders || !this.tabContents) return;

        // Store original parent references to avoid moving elements
        this.tabCustomElements = Array.from(this.querySelectorAll('tab-custom'));

        // Create wrapper structure WITHOUT moving original elements
        const tabHeaderContainer = document.createElement('div');
        const tabHeaderWrapper = document.createElement('div');

        tabHeaderContainer.classList.add('tab-header_container');
        tabHeaderWrapper.classList.add('tab-header_wrapper');

        // Clone headers into the wrapper (don't move originals)
        this.tabHeaders.forEach((tabHeader, index) => {
            const headerClone = tabHeader.cloneNode(true);
            tabHeaderWrapper.append(headerClone);

            if (tabHeader.textContent.includes('°')) {
                this.enableDot = true;
            }

            // Add click event to the CLONE
            headerClone.addEventListener('click', () => this.openTab(index));

            // Hide original headers since we're using clones
            tabHeader.style.display = 'none';
        });

        // Prepend header container (don't move tab content)
        tabHeaderContainer.append(tabHeaderWrapper);

        // Handle tab links
        if (this.tabLinks.length > 0) {
            const tabLinkWrapper = document.createElement('div');
            tabLinkWrapper.classList.add('tab-link_wrapper');
            tabLinkWrapper.classList.add('hidden--mobile');

            this.tabLinks.forEach((tabLink) => {
                // Clone links instead of moving them
                const linkClone = tabLink.cloneNode(true);
                tabLinkWrapper.append(linkClone);
                tabLink.style.display = 'none';
            })

            tabHeaderContainer.append(tabLinkWrapper);
        }

        // Insert header container at the beginning
        this.insertBefore(tabHeaderContainer, this.firstChild);

        // Handle mobile links
        if (this.tabLinksMobile.length > 0) {
            const tabLinkWrapperMobile = document.createElement('div');
            tabLinkWrapperMobile.classList.add('tab-link_wrapper-mobile');
            tabLinkWrapperMobile.classList.add('hidden--desktop');

            this.tabLinksMobile.forEach((tabLink) => {
                const linkClone = tabLink.cloneNode(true);
                tabLinkWrapperMobile.append(linkClone);
                tabLink.style.display = 'none';
            })

            this.append(tabLinkWrapperMobile);
        }

        // Preload images for fade and none animations
        if (this.animationType === 'fade' || this.animationType === 'none') {
            this.tabContents.forEach((tabContent) => {
                const images = tabContent.querySelectorAll('img');
                images.forEach(img => {
                    if (img.src && !img.complete) {
                        const preloadImg = new Image();
                        preloadImg.src = img.src;
                    }
                });
            });
        }

        // Initialize: show first tab
        this.openTab(0);

        // Check if tabs have content
        // document.addEventListener('readystatechange', () => {
        //     if (document.readyState === 'complete') {
        //         const hasContent = this.tabCustomElements.some(el => el.scrollHeight > 0);
        //         if (!hasContent) {
        //             this.classList.add('hidden');
        //             if(this.previousElementSibling?.classList.contains('divider')){
        //                 this.previousElementSibling.classList.add('hidden')
        //             }
        //         }
        //     }
        // });
    }

    openTab(activeIndex) {
        // Get the cloned headers from the wrapper
        const headerClones = this.querySelectorAll('.tab-header_wrapper > tab-header');
        const linkClones = this.querySelectorAll('.tab-link_wrapper > tab-link');
        const mobileLinkClones = this.querySelectorAll('.tab-link_wrapper-mobile > tab-link-mobile');

        // Update cloned headers
        headerClones.forEach((headerClone, i) => {
            headerClone.classList.toggle('active', i === activeIndex);

            if (i === activeIndex && this.enableDot) {
                if (!headerClone.textContent.includes('°')) {
                    headerClone.textContent = '° ' + headerClone.textContent;
                }
            } else {
                headerClone.textContent = headerClone.textContent.replace('° ', '');
            }
        });

        // Update tab content visibility using CSS classes
        // This is the KEY fix - we toggle classes instead of moving elements
        this.tabCustomElements.forEach((tabCustom, i) => {
            tabCustom.classList.toggle('active', i === activeIndex);
        });

        this.tabContents.forEach((tabContent, i) => {
            tabContent.classList.toggle('active', i === activeIndex);
        });

        // Update links
        linkClones.forEach((link, i) => {
            link.classList.toggle('active', i === activeIndex);
        });

        mobileLinkClones.forEach((link, i) => {
            link.classList.toggle('active', i === activeIndex);
        });
    }
}

if (!customElements.get('custom-tabs')) {
    customElements.define('custom-tabs', CustomTabs);
}
